// import gsap from 'gsap'
import { sel, vh } from '../utils'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default function navbar(dataPage) {
  const navbar$ = sel('#navbar')
  if (!navbar$) return
  // navbar$.style.backgroundColor = 'black'
  if (!navbar$.classList.contains('is--0220')) {
    const navbarW$ = navbar$.parentElement
    if (navbarW$.classList.contains('navbar-sticky')) {
      navbar$.style.position = 'sticky'
    } else navbar$.style.position = 'fixed'
    if (!navbar$.classList.contains('is--1210')) {
      const navbarBg = dataPage === 'epic' ? 'rgba(14, 14, 16, 0.5)' : 'rgba(0,0,0,1)'
      // const navbarBg = dataPage === 'epic' ? 'rgba(14, 14, 16, 0.5)' : 'rgba(16, 20, 25, 1)'
      const navbarTl = gsap.fromTo(
        navbar$,
        // { backgroundColor: 'rgba(27,27,27, 0)' },
        { backgroundColor: 'rgba(16, 20, 25, 0)' },
        {
          backgroundColor: navbarBg,
          // backdropFilter: 'blur(10px)',
          ease: 'linear',
          paused: true,
        }
      )
      ScrollTrigger.create({
        trigger: 'body',
        start: vh(10) + 'top',
        // onToggle({ direction, getVelocity }) {
        //   // to reverse the easing
        //   gsap.to(navbarTl, { duration: 1.5, progress: direction === 1 ? 1 : 0, ease: 'expo.out' })
        // },
        toggleActions: 'play none none reverse',
        animation: gsap.to(navbar$, { backgroundColor: navbarBg }),
      })
    } else if (dataPage === 'home2') {
      // gsap.set(navbar$, { '--color--theme-bg': 'white' })
      const navbarTl = gsap.fromTo(
        navbar$,
        {
          borderBottomColor: 'color-mix(in srgb, var(--color--theme-fg), transparent 100%)',
          // backgroundColor: 'color-mix(in srgb, var(--color--theme-init-bg), transparent 100%)',
          // backgroundColor: 'color-mix(in srgb, var(--color--theme-bg), transparent 100%)',
        },
        {
          borderBottomColor: 'color-mix(in srgb, var(--color--theme-fg), transparent 90%)',
          // backgroundColor: 'color-mix(in srgb, var(--color--theme-init-bg), transparent 0%)',
          ease: 'linear',
          paused: true,
        }
      )
      ScrollTrigger.create({
        trigger: 'body',
        start: vh(60) + 'top',
        onToggle({ direction, getVelocity }) {
          // to reverse the easing
          gsap.to(navbarTl, { duration: 1.5, progress: direction === 1 ? 1 : 0, ease: 'expo.out' })
        },
      })
    }
  }
}
